import React, { useMemo, useState } from 'react';
import { ZhipsterDropOption } from './Zhipster';
import RadioButton from '../../Inputs/Radiobutton';
import clsx from 'clsx';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';

interface ZhipsterDropOptionRadioProps extends ZhipsterDropOption {
  checked: boolean;
  onChange: (dropOption: ZhipsterDropOption) => void;
}

const ZhipsterDropOptionRadio = ({
  checked,
  onChange,
  ...dropOption
}: ZhipsterDropOptionRadioProps) => {
  const {
    dropOptionId,
    name,
    description,
    formattedCampaignPrice,
    formattedPrice,
    forwarderId,
  } = dropOption;

  const inputId = useMemo(
    () => `zhipster-drop-option-${dropOptionId}`,
    [dropOptionId]
  );

  const [showImage, setShowImage] = useState(false);

  const { shippingProviderLogos } = useTypedSelector(
    (state) => state.checkout?.payload
  );

  return (
    <label
      htmlFor={inputId}
      className="mb-4 flex flex-1 cursor-pointer items-center rounded border border-solid border-gray-200 px-4 py-3 [&:last-child]:mb-0"
    >
      <div className="flex flex-1 flex-col gap-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <RadioButton
              checked={checked}
              name={inputId}
              type="radio"
              id={inputId}
              onChange={() => onChange(dropOption)}
              inputSize="medium"
            />
            <span className="text-lg font-medium">{name}</span>
          </div>

          <div className="flex items-center justify-center text-md font-light">
            <span>
              <span
                className={clsx(
                  !!formattedCampaignPrice && 'mr-2 line-through'
                )}
              >
                {formattedPrice}
              </span>
              <span>{formattedCampaignPrice}</span>
            </span>
          </div>
        </div>
        <div className="flex flex-1 items-center">
          {description && (
            <span className="text-md font-light">{description}</span>
          )}
          {shippingProviderLogos && (
            <img
              src={shippingProviderLogos[forwarderId.toLowerCase()]}
              onLoad={() => setShowImage(true)}
              alt={name + ' logo'}
              className={clsx('ml-auto', !showImage && 'hidden')}
            />
          )}
        </div>
      </div>
    </label>
  );
};

export default ZhipsterDropOptionRadio;
